import axios from "../axiosInstance"
import { tiposConservacao } from "../shared/utils/Endpoints"

class ConservacaoService {
    async listarTipos(idTipoLote) {
        return await axios.get(tiposConservacao, {
            params: {
                IdTipoLote: idTipoLote ? idTipoLote : null
            },
            cache: true
        });
    }
}

export default new ConservacaoService();